{
  "version": 1,
  "asset_id": "8dd586dd-dcbf-481f-bb7a-9fcdd5e80a22",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/8dd586dd-dcbf-481f-bb7a-9fcdd5e80a22/blog-upload-800.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/8dd586dd-dcbf-481f-bb7a-9fcdd5e80a22/blog-upload-800.avif",
  "original_filename": "blog-upload-800.avif",
  "size": 8645,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:02:31Z"
}
